/* Airholder 360°-Viewer
   Markup: <div data-ah360 data-l='[urls 1600]' data-s='[urls 900]'> … <img data-ah360-img> … <input type=range data-ah360-range> …
   - Frame 00 ist das normale <img> (LCP), weitere Frames laden erst, wenn der Viewer sichtbar ist.
   - Drehen per Ziehen (Maus/Finger, vertikales Scrollen bleibt frei) und per Slider (auch Tastatur).
   - Einmaliger kurzer Dreh-Hinweis nach dem Laden (nicht bei reduzierter Bewegung). */
(function () {
  var LABELS = ['Front', 'Beifahrerseite', 'Heck', 'Fahrerseite'];
  function init(root) {
    if (root.dataset.ah360Ready) return; root.dataset.ah360Ready = '1';
    var L, S; try { L = JSON.parse(root.dataset.l || '[]'); S = JSON.parse(root.dataset.s || '[]'); } catch (e) { return; }
    var n = L.length; if (n < 2) return;
    var img = root.querySelector('[data-ah360-img]'), stage = root.querySelector('[data-ah360-stage]') || img.parentNode;
    var range = root.querySelector('[data-ah360-range]'), bar = root.querySelector('[data-ah360-load]');
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cur = 0, touched = false, loaded = 0, cache = new Array(n), started = false;
    function pick() { var w = (stage.clientWidth || root.parentNode.clientWidth || window.innerWidth) * Math.min(window.devicePixelRatio || 1, 2); return (S.length === n && w <= 1100) ? S : L; }
    var urls = pick();
    function label(i) { var deg = Math.round(i * 360 / n); return LABELS[Math.round(deg / 90) % 4] + ' · ' + deg + '°'; }
    function show(i, fromRange) {
      i = ((Math.round(i) % n) + n) % n; if (i === cur && img.dataset.f == i) return; cur = i;
      var k = i; if (!cache[k] || !cache[k].ok) { // naechsten geladenen Frame nehmen
        for (var d = 1; d < n; d++) { if (cache[(i + d) % n] && cache[(i + d) % n].ok) { k = (i + d) % n; break; } if (cache[(i - d + n) % n] && cache[(i - d + n) % n].ok) { k = (i - d + n) % n; break; } }
      }
      if (cache[k] && cache[k].ok) { img.src = cache[k].src; img.removeAttribute('srcset'); img.dataset.f = k; }
      if (touched) window.ah360Angle = i;
      if (range && !fromRange) range.value = i;
      if (range) range.setAttribute('aria-valuetext', label(i));
      place();
    }
    // Hotspots: data-hs = {"anchors": url, "points": [{key, title, text, imgs: [url…]}]}
    var hs = null, hsA = null, dots = [], card = null, layer = null;
    try { hs = root.dataset.hs ? JSON.parse(root.dataset.hs) : null; } catch (e) { hs = null; }
    function box() { var W = stage.clientWidth, H = stage.clientHeight, s = Math.min(W / 1600, H / 1200); return { s: s, x: (W - 1600 * s) / 2, y: (H - 1200 * s) / 2 }; }
    function place() {
      if (!hsA || !dots.length || layer.hidden) return; var f = img.dataset.f != null ? +img.dataset.f : 0, b = box();
      var W = stage.clientWidth, H = stage.clientHeight, mob = W < 520, vis = [];
      dots.forEach(function (d) { var a = (hsA[d.key] || [])[f];
        if (!a || !a[2]) { d.el.hidden = true; d.pin.style.display = 'none'; d.line.style.display = 'none'; return; }
        vis.push({ d: d, x: b.x + a[0] * b.s, y: b.y + a[1] * b.s }); });
      // Seite je Punkt: naeher am Rand; liegen alle auf einer Seite, wandert der mittigste auf die andere
      vis.forEach(function (v) { v.left = v.x < W / 2; });
      if (vis.length > 1 && vis.every(function (v) { return v.left === vis[0].left; })) {
        var m = vis.slice().sort(function (p, q) { return Math.abs(p.x - W / 2) - Math.abs(q.x - W / 2); })[0]; m.left = !m.left; }
      [true, false].forEach(function (side) {
        var g = vis.filter(function (v) { return v.left === side; }).sort(function (p, q) { return p.y - q.y; });
        var gap = mob ? 30 : 42, top = mob ? 64 : 62, lastY = -1e9;
        g.forEach(function (v) { var ly = Math.max(Math.min(v.y - (mob ? 20 : 36), H / 2 - (mob ? 30 : 36)), top, lastY + gap); v.ly = ly; lastY = ly; });
      });
      vis.forEach(function (v) {
        var d = v.d, el = d.el; el.hidden = false; el.classList.toggle('is-right', !v.left); el.classList.toggle('is-compact', mob);
        var ew = el.offsetWidth, eh = el.offsetHeight, pad = mob ? 8 : 16;
        var lx = v.left ? pad : W - pad - ew; el.style.transform = 'translate(' + lx + 'px,' + (v.ly - eh / 2) + 'px)';
        var sx = v.left ? lx + ew : lx, ex = v.left ? sx + (mob ? 10 : 18) : sx - (mob ? 10 : 18);
        d.line.setAttribute('points', sx + ',' + v.ly + ' ' + ex + ',' + v.ly + ' ' + v.x + ',' + v.y); d.line.style.display = '';
        d.pin.style.display = ''; d.pin.style.transform = 'translate(' + v.x + 'px,' + v.y + 'px)';
      });
    }
    function closeCard() { if (card) { card.hidden = true; dots.forEach(function (d) { d.el.setAttribute('aria-expanded', 'false'); }); } }
    function openCard(p, btn) {
      if (!card) { card = document.createElement('div'); card.className = 'ah360__card'; card.setAttribute('role', 'dialog'); stage.appendChild(card);
        card.addEventListener('pointerdown', function (e) { e.stopPropagation(); }); }
      var imgs = (p.imgs || []).map(function (u, k) { return '<img src="' + u + '" alt="' + (p.alts && p.alts[k] ? p.alts[k] : p.title) + '" width="900" height="675" loading="lazy"' + (k ? ' hidden' : '') + '>'; }).join('');
      var tabs = (p.imgs || []).length > 1 ? '<div class="ah360__cardtabs">' + p.tabs.map(function (t, k) { return '<button type="button" data-k="' + k + '"' + (k ? '' : ' aria-pressed="true"') + '>' + t + '</button>'; }).join('') + '</div>' : '';
      card.innerHTML = '<button type="button" class="ah360__cardx" aria-label="Schließen">×</button><div class="ah360__cardimg">' + imgs + '</div>' + tabs + '<b>' + p.title + '</b><p>' + p.text + '</p>';
      card.setAttribute('aria-label', p.title); card.hidden = false;
      dots.forEach(function (d) { d.el.setAttribute('aria-expanded', d.el === btn ? 'true' : 'false'); });
      card.querySelector('.ah360__cardx').addEventListener('click', function () { closeCard(); btn.focus(); });
      card.querySelectorAll('[data-k]').forEach(function (t) { t.addEventListener('click', function () {
        var k = +t.dataset.k; card.querySelectorAll('.ah360__cardimg img').forEach(function (im, j) { im.hidden = j !== k; });
        card.querySelectorAll('[data-k]').forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); }); }); });
    }
    if (hs && hs.points && hs.points.length) {
      layer = document.createElement('div'); layer.className = 'ah360__hs'; layer.hidden = true; stage.appendChild(layer);
      var tg = document.createElement('button'); tg.type = 'button'; tg.className = 'ah360__hstoggle'; tg.setAttribute('role', 'switch'); tg.setAttribute('aria-checked', 'false'); tg.setAttribute('aria-pressed', 'false');
      tg.innerHTML = '<span>Details</span><i class="ah360__sw" aria-hidden="true"><b></b></i>';
      tg.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
      tg.addEventListener('click', function (e) { e.stopPropagation(); var on = tg.getAttribute('aria-pressed') !== 'true';
        tg.setAttribute('aria-pressed', on ? 'true' : 'false'); tg.setAttribute('aria-checked', on ? 'true' : 'false'); layer.hidden = !on; root.classList.toggle('is-hs', on);
        if (!on) closeCard(); else place(); });
      stage.appendChild(tg);
      var NS = 'http://www.w3.org/2000/svg', svg = document.createElementNS(NS, 'svg'); svg.setAttribute('class', 'ah360__lines'); svg.setAttribute('aria-hidden', 'true'); layer.appendChild(svg);
      hs.points.forEach(function (p, k) {
        var line = document.createElementNS(NS, 'polyline'); line.style.display = 'none'; svg.appendChild(line);
        var pin = document.createElement('i'); pin.className = 'ah360__pin'; pin.style.display = 'none'; layer.appendChild(pin);
        var b = document.createElement('button'); b.type = 'button'; b.className = 'ah360__dot'; b.hidden = true;
        b.setAttribute('aria-expanded', 'false'); b.innerHTML = '<span>' + (k + 1) + '</span><em>' + p.short + '</em>';
        b.setAttribute('aria-label', p.title);
        b.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
        b.addEventListener('click', function (e) { e.stopPropagation(); if (!card || card.hidden || b.getAttribute('aria-expanded') !== 'true') openCard(p, b); else closeCard(); });
        layer.appendChild(b); dots.push({ key: p.key, el: b, pin: pin, line: line });
      });
      fetch(hs.anchors).then(function (r) { return r.json(); }).then(function (a) { hsA = a; place(); }).catch(function () {});
      window.addEventListener('resize', place);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCard(); });
    }
    function load() {
      if (started) return; started = true; root.classList.add('is-loading');
      urls = pick();
      var order = []; // grob verteilt laden: erst jeder 6., dann Rest
      for (var a = 0; a < n; a += 6) order.push(a); for (var b = 0; b < n; b++) if (b % 6) order.push(b);
      var q = order.slice(), active = 0;
      function next() {
        while (active < 6 && q.length) {
          (function (i) {
            active++; var im = new Image(); im.decoding = 'async';
            im.onload = function () { cache[i] = { ok: true, src: urls[i] }; if (i === cur || img.dataset.f != cur) show(cur); done(); };
            im.onerror = function () { cache[i] = { ok: false }; done(); };
            function done() { active--; loaded++; if (bar) bar.style.width = (loaded / n * 100) + '%'; if (loaded === n) ready(); else next(); }
            im.src = urls[i];
          })(q.shift());
        }
      }
      next();
    }
    function ready() {
      root.classList.remove('is-loading'); root.classList.add('is-ready');
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { io.disconnect(); var go = function () { load(); }; if (document.readyState === 'complete') setTimeout(go, 150); else window.addEventListener('load', function () { setTimeout(go, 150); }); } }, { rootMargin: '200px' });
      io.observe(root);
    } else load();
    // Ziehen: eine volle Umdrehung pro ~1,4 Buehnenbreiten
    var x0 = null, y0 = 0, f0 = 0, drag = false;
    stage.addEventListener('pointerdown', function (e) { if (e.button > 0) return; x0 = e.clientX; y0 = e.clientY; f0 = cur; drag = false; load(); });
    stage.addEventListener('pointermove', function (e) {
      if (x0 === null) return; var dx = e.clientX - x0;
      if (!drag) { if (Math.abs(dx) < 6) return; if (Math.abs(e.clientY - y0) > Math.abs(dx)) { x0 = null; return; } drag = true; touched = true; root.classList.add('is-drag', 'is-touched'); try { stage.setPointerCapture(e.pointerId); } catch (_) {} }
      e.preventDefault(); show(f0 - dx / (stage.clientWidth * 1.4) * n);
    });
    function end() { x0 = null; if (drag) setTimeout(function () { root.classList.remove('is-drag'); }, 0); }
    stage.addEventListener('pointerup', end); stage.addEventListener('pointercancel', end);
    stage.addEventListener('click', function (e) { if (drag) { e.preventDefault(); e.stopPropagation(); drag = false; } }, true);
    stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
    if (range) {
      range.max = n - 1;
      range.addEventListener('input', function () { touched = true; load(); show(+range.value, true); });
      range.addEventListener('focus', load);
    }
    root.ah360 = { show: function (i) { show(i); }, cur: function () { return cur; }, load: load };
    show(0);
  }
  document.addEventListener('v3:variant', function () {
    setTimeout(function () {
      if (window.ah360Angle == null) return;
      document.querySelectorAll('[data-ah360]').forEach(function (r) { if (r.ah360 && r.offsetParent !== null) r.ah360.show(window.ah360Angle); });
    }, 0);
  });
  // Karten: Mausposition dreht (nur Geraete mit Maus)
  function initCard(img) {
    if (img.dataset.ah360Ready) return; img.dataset.ah360Ready = '1';
    if (!(window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches)) return;
    var u; try { u = JSON.parse(img.dataset.ah360Hover); } catch (e) { return; }
    var box = img.parentNode, first = img.src, ok = [], pre = false, last = 0;
    function preload() { if (pre) return; pre = true; u.forEach(function (x, k) { var im = new Image(); im.onload = function () { ok[k] = true; }; im.src = x; }); ok[0] = true; }
    box.addEventListener('pointerenter', preload);
    box.addEventListener('pointermove', function (e) {
      var r = box.getBoundingClientRect(), f = Math.min(.999, Math.max(0, (e.clientX - r.left) / r.width));
      var k = Math.floor(f * u.length); if (k === last || !ok[k]) return; last = k; img.src = u[k];
    });
    box.addEventListener('pointerleave', function () { last = 0; img.src = first; });
  }
  function all() { document.querySelectorAll('[data-ah360]').forEach(init); document.querySelectorAll('[data-ah360-hover]').forEach(initCard); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
  window.ah360 = { init: init, all: all };
})();
